import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class InputGroup extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'no-event-bubble': `boolean`,
      busy: `boolean`,
      disabled: `boolean`,
      icon: `string`,
      label: {type: `string`, default: `Save`},
      placeholder: `string`,
      readonly: `boolean`,
      theme: `string`,
      value: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        value: ``,
      },
      helpers: {
        setValue: (ev) => {
          this.update({value: ev.target.value});
          this.dispatchEvent(new Event(`change`));
        },
        submitIfEnter: (ev) => {
          if (ev.keyCode === 13) {
            this._submitIfValid();
          }
        },
        submit: () => {
          this._submitIfValid();
        },
      },
    };
  }

  get value() {
    return this.state.value;
  }

  set value(value) {
    this.update({value});
  }

  focus() {
    return this.el.querySelector(`input`).focus();
  }

  select() {
    return this.el.querySelector(`input`).select();
  }

  _submitIfValid() {
    if (this.state.value && !this.attr(`busy`)) {
      this.dispatchEvent(new Event(`submit`, {bubbles: !this.attr(`no-event-bubble`), composed: true}));
    }
  }

  _updateValueFromAttr() {
    this.update({value: this.attr(`value`)});
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    if (this.attr(`value`)) {
      this._updateValueFromAttr();
    }
  }

  attributeChangedCallback(attr) {
    super.attributeChangedCallback(...arguments);
    if (this.initialized && attr === `value`) {
      this._updateValueFromAttr();
    }
  }
}

export const InputGroupEl = defineAndMakeJsxFactory(`mp-input-group`, InputGroup);
